import Button from "@components/ui/Button";
import { attemptGapsProblem } from "@components/scheduling/settings/settingsValidation";

const inputClass =
  "w-20 border border-gray-300 rounded-lg px-2 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

const MAX_GAPS = 4;
const DEFAULT_GAP = 3;

/**
 * How many follow-up attempts a campaign makes, and how many days after the
 * previous call each one waits. A patient who books, declines or asks for a
 * callback ends the schedule early; this editor only sets the schedule
 * itself.
 *
 * An empty box is kept as "", the same way the cooldown input does, so
 * backspacing to retype a number never silently becomes 0 days later.
 */
export default function AttemptGapsEditor({ gaps, onChange }) {
  const rows = gaps || [];
  const problem = attemptGapsProblem(rows);

  const update = (index, value) => {
    onChange(rows.map((gap, i) => (i === index ? value : gap)));
  };

  return (
    <div className="space-y-3">
      {rows.map((gap, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="flex items-center gap-2">
          <input
            type="number"
            min="1"
            max="14"
            step="1"
            className={inputClass}
            aria-label={`Follow-up ${index + 1} days after the previous call`}
            value={gap}
            onChange={(e) => update(index, e.target.value === "" ? "" : Number(e.target.value))}
          />
          <span className="text-sm text-gray-600">days after the previous call</span>
          <Button color="light" size="xs"
                  aria-label={`Remove follow-up ${index + 1}`}
                  onClick={() => onChange(rows.filter((_, i) => i !== index))}>
            Remove
          </Button>
        </div>
      ))}
      <Button color="light" size="sm" disabled={rows.length >= MAX_GAPS}
              onClick={() => onChange([...rows, DEFAULT_GAP])}>
        Add a follow-up
      </Button>
      <p className="text-xs text-gray-500">
        {`${rows.length + 1} attempts: day 0${rows.map((g) => `, +${g} day${g === 1 ? "" : "s"}`).join("")}`}
      </p>
      {problem && <p className="mt-1 text-xs text-red-600">{problem}</p>}
    </div>
  );
}
